import React  from 'react';
import { Link } from 'react-router-dom';

// Components.
import Logo from 'components/Welltory/Logo';

// Styles.
import styles from './styles.module.scss';

const HeaderLogo = (props) => {

  return (
    <Link to="/user/profile" className={styles.logoLink}>
      <Logo width={158} height={40} theme={props.theme} />
    </Link>
  );

};

export default HeaderLogo;
